
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/project/sale",
      function () {
        return require("private-next-pages/service/project/sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/project/sale"])
      });
    }
  